import '.a{display:flex;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.bg{gap:0.5rem;}.ssr-plugin'
import '.b3{cursor:pointer;}.ssr-plugin'
import '.hs{padding:0.75rem;}.ssr-plugin'
import '.ag{border-radius:1.25rem;}.ssr-plugin'
import '.ba{border:var(--blue-border);}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.d6{transition:background-color 0.2s ease;}.ssr-plugin'
import '.dx{width:2.5rem;}.ssr-plugin'
import '.dy{height:2.5rem;}.ssr-plugin'
import '.ht{color:var(--shades-blue-700);}.ssr-plugin'
import '.hu{font-size:0.9rem;}.ssr-plugin'
import '.au{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a g b c bg b3 hs ag ba ah d6"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="dx dy a c g ht"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hu ht au"
        >
          {label}
        </span>
      </styled.button>
    )
}